import {
  AutofpsSelectRounded,
  CalendarMonthOutlined,
  CategoryOutlined,
  HistoryEduOutlined,
  LocationOnOutlined,
  NoteAltOutlined,
  PersonOutlineOutlined,
  PhoneOutlined,
  WorkspacePremiumOutlined,
} from '@mui/icons-material';
import { Alert, Grid, Snackbar } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import Zoom from 'react-medium-image-zoom';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Images from '../../../../Configs/images';
import { renderIndicator } from '../../../../Utils/helpers';
import Elements from '../../../Elements';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'react-medium-image-zoom/dist/styles.css';
import { getCourier } from '../../../../Redux/Models/courier';

export default function Couriers({ classes }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const { devId } = useParams();

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    dispatch(getCourier());
  }, []);

  return (
    <Elements.AdminPageBase navigate={navigate} title="Couriers">
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <div className="flex space-between mt-1">
          <div>
            Total couriers
            {' '}
            <strong>8</strong>
          </div>
          <Link to="all" className="link weight-700 black">See all couriers</Link>
        </div>

        <div className="mt-4">
          <Grid container spacing={2}>
            <Grid item lg={4}>
              <div className="couriers-container ">
                <div className="card-head">
                  <div className="flex space-between align-items-center">
                    <div className="flex align-items-center gap-8 pil">
                      <img src={Images.CheckRounded} alt="available" />
                      <div className="s-16 weight-700">Available</div>
                    </div>
                    <div className="qty s-12 white weight-700">5</div>
                  </div>
                </div>

                <div className="request-card">
                  <div>
                    <div className="flex space-between align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item lg={4}>
              <div className="couriers-container ">
                <div className="card-head">
                  <div className="flex space-between align-items-center">
                    <div className="flex align-items-center gap-8 pil">
                      <img src={Images.AvailableCouriers} width="24" alt="on duty" />
                      <div className="s-16 weight-700">On duty</div>
                    </div>
                    <div className="qty s-12 white weight-700">5</div>
                  </div>
                </div>

                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
                <div className="request-card">
                  <div>
                    <img alt="request-in" src={Images.RequestOutOrange} />
                    <div className="flex space-between mt-2 align-items-center">
                      <div className="weight-700">Justin Doe</div>
                      <div className="s-12">U123</div>
                    </div>
                    <div className="s-14 mt-2">09.00 -  20/05/2022</div>
                    <div className="s-12 mt-2">France france france France france ...</div>
                    <div className="right s-12 mute mt-2">15 seconds ago</div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item lg={4}>
              <div className="sticky aside">
                <dispatchEvent>
                  <Carousel
                    showThumbs={false}
                    showStatus={false}
                    infiniteLoop
                    showArrows={false}
                    renderIndicator={renderIndicator}
                  >
                    {[
                      'https://thumb.viva.co.id/media/frontend/thumbs3/2016/09/02/57c907826c21e-tujuh-gunung-tertinggi-di-sumatra_1265_711.jpg',
                      'https://thumb.viva.co.id/media/frontend/thumbs3/2016/09/02/57c907826c21e-tujuh-gunung-tertinggi-di-sumatra_1265_711.jpg',
                    ].map((asset, index) => (
                      <div key={index} className="relative">
                        <Zoom>
                          <img src={asset} alt="testasset" style={{ width: '100%', borderRadius: 16 }} />
                        </Zoom>
                      </div>
                    ))}
                  </Carousel>

                  <div className="no-img" />
                </dispatchEvent>

                <div className="mt-4 additional-info">
                  <h3>Courier info</h3>
                  <div className="flex align-items-center mt-3">
                    <PersonOutlineOutlined fontSize="small" />
                    <div className="s-16">Jogn Doe</div>
                  </div>
                  <div className="flex align-items-center mt-3">
                    <WorkspacePremiumOutlined fontSize="small" />
                    <div className="s-16">Premium User</div>
                  </div>
                  <div className="flex align-items-center mt-3">
                    <CalendarMonthOutlined fontSize="small" />
                    <div className="s-16">09.00 -  20/05/2022</div>
                  </div>
                  <div className="flex mt-3">
                    <LocationOnOutlined fontSize="small" />
                    <div className="s-16">France france france France france france france</div>
                  </div>
                  <div className="flex align-items-center mt-3">
                    <PhoneOutlined fontSize="small" />
                    <div className="s-16">+26881132789</div>
                  </div>
                </div>

                <div className="mt-4 additional-info">
                  <h3>Task info</h3>
                  <div className="flex align-items-center mt-3">
                    <CategoryOutlined fontSize="small" />
                    <div className="s-16">6 items</div>
                  </div>
                  <div className="flex align-items-center mt-3">
                    <AutofpsSelectRounded fontSize="small" />
                    <div className="s-16">Good conditions</div>
                  </div>
                  <div className="flex mt-3">
                    <HistoryEduOutlined fontSize="small" />
                    <div className="s-16">
                      Lorem ipsum dolor sit amet,
                      consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt
                      ut labore et dolore magna aliqua.
                    </div>
                  </div>
                  <div className="flex align-items-center mt-3">
                    <NoteAltOutlined fontSize="small" />
                    <div className="s-16">Wine Asgard 1990, Wine Asgar 1990</div>
                  </div>
                </div>

              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    </Elements.AdminPageBase>
  );
}
